import { useStore } from '../store/useStore';

/**
 * Hook to get the current system date as YYYY-MM-DD.
 */
export const useSystemDate = () => {
  return useStore(state => state.systemDate);
};
